import { RouteObject } from "react-router-dom";
import QuestionsLayout from "src/layouts/QuestionsLayout";
import { Matches } from "../matches";
import Questions from "src/pages/Questions";
import UpsellLayout from "src/layouts/UpsellLayout";
import { Paths } from "../paths";
import PageTrackerProvider from "src/context/PageTrackerProvider";
import AuthQueue from "src/pages/transitions/AuthQueue";
import QuestionsProvider from "src/context/QuestionsProvider";
import { ProgressProvider } from "src/context/ProgressContext";

export const upsellRoutes: RouteObject[] = [
  {
    element: (
      <PageTrackerProvider>
        <ProgressProvider>
          <QuestionsProvider>
            <UpsellLayout />
          </QuestionsProvider>
        </ProgressProvider>
      </PageTrackerProvider>
    ),
    children: [
      {
        path: "add-ons",
        element: <QuestionsLayout />,
        children: [
          {
            path: Matches.QUESTION_ID,
            element: <Questions />,
          },
          {
            path: "shipping-information",
            element: <AuthQueue />,
          },
        ],
      },
      {
        path: Paths.ONE_TIME_PAYMENT_INFORMATION,
        element: <AuthQueue />,
      },
    ],
  },
];
